import { cookies } from 'sharedKernel/cookies/behavior'
import { getCredLocalStorage } from 'sharedKernel/auth/credLocalStorage'

export const isUserOwner = (ownerId: string): boolean => {
  const credentials = cookies.get('_cred')

  if (!credentials || !credentials.data) {
    return false
  }

  const company = getCredLocalStorage()?.company

  if (!company || !company.id) {
    return false
  }

  const companyId = company.id
  return companyId === ownerId
}
